/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical, faRotate } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import BroadcastLibraryIcon from "../../../assets/icons/prod_broadcast.svg2";
import { useGetBroadcastersQuery } from "../../store/slices/settingsSlice";
import HelpButton from "../../HelpContent/HelpButton";
import { AbsoluteLoadingIndicator } from "../FullScreenLoadingIndicator";

export default function BroadcastsWidget() {
  const { data: broadcastsData, isLoading, isFetching, refetch } =
    useGetBroadcastersQuery();
  const loading = isLoading || isFetching;

  return (
    <div className="position-relative px-2 d-flex flex-column h-100">
      <AbsoluteLoadingIndicator loading={loading} />
      <div className="d-flex p-3 pb-1 align-items-center ">
        <BroadcastLibraryIcon width={20} className="white opacity-50" />
        <Link className="btn p-0 text-white" to="/library/broadcast">
          <h6 className="m-0 mx-2 small fw-bold">BROADCAST</h6>
        </Link>
        <button
          className="btn p-0 text-white ms-2"
          onClick={() => refetch()}
          title="Refresh broadcast data"
          disabled={loading}
        >
          <FontAwesomeIcon
            icon={faRotate}
            className={`opacity-50 ${loading ? "spin" : ""}`}
          />
        </button>
        <HelpButton helpKey="widget-broadcasts" iconClassName="white" />{" "}
        <FontAwesomeIcon
          icon={faGripVertical}
          className="ms-4 opacity-50 widget-header"
        />
      </div>
      <div>
        {[
          {
            label: (
              <div className="opacity-50">
                <Link className="btn p-0 text-white" to="/library/broadcast">
                  Broadcasts
                </Link>
              </div>
            ),
            value: `${broadcastsData?.total || 0}`,
          },
        ].map((r, i) => (
          <React.Fragment key={i}>
            <hr className="m-1" />
            <div className="d-flex justify-content-between px-3">
              <span className="fw-bold p-1">{r.label}</span>
              <h3 className="fw-bold m-0 p-1">{r.value}</h3>
            </div>
          </React.Fragment>
        ))}
      </div>
      <div className="flex-grow-1" />

      {/* <div className="px-3">
        <hr />
        <button
          type="button"
          className={`btn btn-light btn-sm px-2 py-0 rounded-pill text-purple fw-bold mx-1 ${
            period === "" ? "" : "opacity-50"
          }`}
          onClick={() => setPeriod("")}
        >
          ALL
        </button>
        <button
          type="button"
          className={`btn btn-light btn-sm px-2 py-0 rounded-pill text-purple fw-bold mx-1 ${
            period === "today" ? "" : "opacity-50"
          }`}
          onClick={() => setPeriod("today")}
        >
          DAY
        </button>
        <button
          type="button"
          className={`btn btn-light btn-sm px-2 py-0 rounded-pill text-purple fw-bold mx-1 ${
            period === "week" ? "" : "opacity-50"
          }`}
          onClick={() => setPeriod("week")}
        >
          WEEK
        </button>
        <button
          type="button"
          className={`btn btn-light btn-sm px-2 py-0 rounded-pill text-purple fw-bold mx-1 ${
            period === "month" ? "" : "opacity-50"
          }`}
          onClick={() => setPeriod("month")}
        >
          MONTH
        </button>
      </div>
      <div className="p-2">{datePeriod().html}</div> */}
    </div>
  );
}
